import { useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { Layout } from '@/shell/Layout'
import { useSelectedOrg } from '@/context/SelectedOrgContext'
import { useOpenCreatedOrg } from '@/lib/useSwitchOrg'
import { CreateOrgWizard } from '@/features/org/components/CreateOrgWizard'
import { PageLoading } from '@/shared/components/EmptyState'
import { FeedbackMessage } from '@/shared/components/FeedbackMessage'
import { OrgDetail } from '@/features/org/OrgDetail'
import { type OrgTab } from '@/features/org/tabs/orgTabs'

export function Org() {
  const { orgSlug } = useParams()
  // The context list is the one OrgLayout validates the URL against - a private
  // useOrgs() here would leave a just-created org invisible to that check.
  const { orgs, orgsLoading, orgsError, refetchOrgs } = useSelectedOrg()
  const selectedOrg = orgs.find((o) => (o.slug ?? o.id) === orgSlug)
  const openCreatedOrg = useOpenCreatedOrg()
  const [searchParams] = useSearchParams()
  const initialTab = searchParams.get('tab') as OrgTab | null
  const [showCreateOrg, setShowCreateOrg] = useState(false)

  return (
    <Layout title="Organisation Settings">
      {showCreateOrg && (
        <CreateOrgWizard
          onClose={() => setShowCreateOrg(false)}
          onCreated={async (org) => { setShowCreateOrg(false); await openCreatedOrg(org) }}
        />
      )}

      {orgsLoading && <PageLoading />}
      {orgsError && <FeedbackMessage ok={false} msg={orgsError} />}

      {selectedOrg && <OrgDetail org={selectedOrg} onUpdated={refetchOrgs} initialTab={initialTab ?? undefined} />}

      {!orgsLoading && !selectedOrg && !orgsError && (
        <div className="empty-state fu">
          <div className="empty-icon">⬡</div>
          <div>No organisations yet.</div>
          <button className="btn btn-ghost btn-sm" style={{ marginTop: 8 }} onClick={() => setShowCreateOrg(true)}>
            Create your first org
          </button>
        </div>
      )}
    </Layout>
  )
}

